/**
 * TQC3020_R01 - 출고Lot 이력추적 조회 DTO
 */
import { SalesHeaderDto } from "src/dtos/sales/salesBillDto";
import { WmsTransportHeaderDto, WmsTransportLotDto } from "src/dtos/wmsTransport/wmsTransportDto";
import { ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { toLocalDateTime } from "src/utils/string/stringUtil";

// ========== 매출기준 조회 ==========

/**
 * 매출 헤더/상세 정보 DTO
 */
export interface TQC3020_R01SalesDto extends SalesHeaderDto {
	salesBillNo: string;         // 매출전표번호
	customNmFull: string;        // 거래처명 (전체)
	itemCd: string;              // 품목코드
	itemNm: string;              // 품명
	itemSpec: string;            // 규격
	locationCd?: string;
	locationNm?: string;
	modelNo: string;             // 모델명
	salesQty: number;            // 매출수량
	basOrderType: string;        // 기준오더유형 (출고유형)
	basOrderNo: string;          // 기준오더번호 (출고번호)
	basOrderItemNo: string;      // 기준오더항목번호 (출고항목번호)
}

export const defaultTQC3020_R01SalesDto: TQC3020_R01SalesDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	salBillNo: '',
	salesBillNo: '',
	compCd: '',
	compNm: '',
	customCd: '',
	customNm: '',
	salesDt: undefined,
	deliveryDt: undefined,
	vatType: '',
	moneyCd: '',
	salesAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	post: '',
	address: '',
	detailAddress: '',
	periodDt: undefined,
	telNo: '',
	faxNo: '',
	taxBilling: '',
	taxBillNo: '',
	empNo: '',
	empNm: '',
	approveFlg: '',
	transportNo: '',
	remark: '',

	customNmFull: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	locationCd: '',
	locationNm: '',
	modelNo: '',
	salesQty: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	
	inserted: false,
	isModified: false,
}

/**
 * 매출기준 Lot 조회 DTO
 */
export interface TQC3020_R01SalesLotDto extends WmsTransportLotDto {}

export const defaultTQC3020_R01SalesLotDto: TQC3020_R01SalesLotDto = {
	transportNo: '',
	itemNo: '',
	itemCd: '',
	lotNo: '',
	itemStatus: '',
	purchaseLotNo: '',
	lotQty: 0,
	unit: '',
	remark: '',
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	inserted: false,
	isModified: false,
}


// ========== 생산기준 조회 ==========

/**
 * 생산기준 조회 DTO (LOT 제외)
 */
export interface TQC3020_R01ProductBaseDto extends ProductResultDto {
	workProcess?: string;        // 공정코드
	workProcessNm?: string;      // 공정명
	modelNo: string;             // 모델명
	locationCd?: string;
	locationNm?: string;
	lotNo?: string | null;       // LotNo
	lotQty?: number | null;      // Lot수량
}

export const defaultTQC3020_R01ProductBaseDto: TQC3020_R01ProductBaseDto = {
	productResultNo: '',
	orderIndex: 0,
	orderIndexSeq: 0,
	valueIndex: 0,
	orderType: '',
	basOrderNo: '',
	basOrderType: '',
	basOrderItemNo: '',
	compCd: '',
	compNm: '',
	productDt: undefined,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	workProcess: '',
	workProcessNm: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	modelNo: '',
	locationCd: '',
	locationNm: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	acceptQty: 0,
	productQty: 0,
	badQty: 0,
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	inserted: false,
	isModified: false,
}

/**
 * 생산기준 Lot 조회 DTO
 */
export interface TQC3020_R01ProductLotDto extends ProductResultDto {
	lotNo: string;              // LotNo
	lotQty: number;             // 생산 Lot량
	unit?: string;              // 단위
}

export const defaultTQC3020_R01ProductLotDto: TQC3020_R01ProductLotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: undefined,
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',
	remark: '',

	lotNo: '',
	lotQty: 0,
	unit: '',
	inserted: false,
	isModified: false,
}

/**
 * Lot 생산 정보 조회 DTO
 */
export interface TQC3020_R01ProductResultDto extends ProductResultDto {
	// 화면 표시용 별칭(백엔드 응답에서 empNm으로 내려오는 케이스 호환)
	empNm?: string;
}

export const defaultTQC3020_R01ProductResultDto: TQC3020_R01ProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: undefined,
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	acceptQty: 0,
	empNm: '',
	productQty: 0,
	badQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',

	remark: '',
	inserted: false,
	isModified: false,
}


/**
 * LOT별 생산 정보 상세 조회 DTO (삭제 예정 - 더 이상 사용 안 함)
 * @deprecated 실제 쿼리는 Lot 번호 기준으로 생산이력을 조회함
 */
export interface TQC3020_R01LotProductInfoDto {
	lotNo: string;              // Lot No
	productResultNo: string;     // 생산실적번호
	productDt: string;           // 생산일자
	productOrderNo?: string;     // 생산오더번호
	productEmp: string;         // 작업자 코드
	empNm: string;              // 작업자명
	workProcess: string;         // 공정 코드
	workplaceNm: string;         // 공정명
	productQty: number;         // 생산수량
	badQty: number;             // 불량수
	stockQty: number;           // 현재고
	valueIndex?: number;         // 그리드 행 고유 인덱스
	inserted?: boolean;          // 그리드용 속성
}

// ========== 자재 투입 정보 조회 ==========

/**
 * 자재·재공품 투입(소비) 내역 DTO
 */
export interface TQC3020_R01BomDto extends WmsTransportHeaderDto {
	itemCd: string;              // 품목코드
	itemNm: string;              // 품명
	itemSpec: string;            // 규격
	locationCd?: string;
	locationNm?: string;
	lotQty: number;             // 투입수량
	lotNo: string;              // Lot 번호
}

export const defaultTQC3020_R01BomDto: TQC3020_R01BomDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	transportNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	transportDt: undefined,
	inoutType: '',
	inoutClass: '',
	customCd: '',
	customNm: '',
	otherLogicCenter: '',
	inoutMethod: '',
	empNo: '',
	empNm: '',
	transAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	trackingNo: '',
	approveFlg: '',
	remark: '',

	itemCd: '',
	itemNm: '',
	itemSpec: '',
	locationCd: '',
	locationNm: '',
	lotQty: 0,
	lotNo: '',
	inserted: false,
	isModified: false,
}

// ========== 재고/입고 정보 조회 ==========

/**
 * 자재·재공품 Lot 입고 근거 DTO
 */
export interface TQC3020_R01StockDto extends WmsTransportHeaderDto {
	inoutClassNm?: string;       // 입출고구분명
	lotNo: string;              // Lot 번호
	qty: number;                // 수량
}

export const defaultTQC3020_R01StockDto: TQC3020_R01StockDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	transportNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	transportDt: undefined,
	inoutType: '',
	inoutClass: '',
	customCd: '',
	customNm: '',
	otherLogicCenter: '',
	inoutMethod: '',
	empNo: '',
	empNm: '',
	transAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	trackingNo: '',
	approveFlg: '',
	remark: '',

	inoutClassNm: '',
	lotNo: '',
	qty: 0,
	inserted: false,
	isModified: false,
}

// ========== 필터 타입 ==========

/**
 * 매출기준 조회 필터
 */
export interface TQC3020_R01SalesFilter {
	startDate?: string;          // 출고일자 시작일 (YYYY-MM-DD)
	endDate?: string;            // 출고일자 종료일 (YYYY-MM-DD)
	compCdCondition?: string;    // 사업장 조건
	customCdCondition?: string;  // 거래처코드 조건
	itemCdCondition?: string;    // 품목코드 조건
	listLength?: number;         // 페이징: 조회할 목록 길이
	refetchListLength?: number;   // 페이징: 재조회할 목록 길이
}

/**
 * 생산기준 조회 필터
 */
export interface TQC3020_R01ProductBaseFilter {
	startDate?: string;          // 생산일자 시작 (YYYY-MM-DD)
	endDate?: string;             // 생산일자 종료 (YYYY-MM-DD)
	compCdCondition?: string;    // 사업장 조건
	itemCdCondition?: string;     // 품목코드 조건
	workplaceCdCondition?: string; // 공정정보 등록 코드 조건
	listLength?: number;          // 페이징: 조회할 목록 길이
	refetchListLength?: number;    // 페이징: 재조회할 목록 길이
}

/**
 * 생산실적 정보 조회 필터
 */
export interface TQC3020_R01ProductResultFilter {
	salesBillNo?: string;        // 매출전표번호 (필수)
	itemNo?: string;            // 항목번호 (매출상세의 item_no) (필수)
	listLength?: number;          // 페이징: 조회할 목록 길이
	refetchListLength?: number;   // 페이징: 재조회할 목록 길이
}

/**
 * 재고/입고 정보 조회 필터
 */
export interface TQC3020_R01StockFilter {
	salesBillNo?: string;        // 매출전표번호 (필수)
	itemNo?: string;            // 항목번호 (매출상세의 item_no) (필수)
	startDate?: string;          // 입고일자 시작일 (YYYY-MM-DD)
	endDate?: string;             // 입고일자 종료일 (YYYY-MM-DD)
	listLength?: number;          // 페이징: 조회할 목록 길이
	refetchListLength?: number;   // 페이징: 재조회할 목록 길이
}

